import React, { memo, useCallback } from 'react';
import { ConfirmationPage } from '@nexus/lib-react/dist/core/ConfirmationPage/ConfirmationPage';
import ButtonPrimaryDark from '@nexus/lib-react/dist/core/Button/ButtonPrimaryDark';
import { Headline5 } from '@nexus/lib-react/dist/core/Typography/Heading';
import { useI18n } from '../../i18n';
import FlameIcon from './icons/Flame';

import S from './style/ErrorPage';

const i18nKey = subKey => `dlv_errorpage_${subKey}`;

const backToHome = url => {
  window.location.href = url;
};

function ErrorPage({ status, homeUrl }) {
  const i18n = useI18n();

  const onClickHandler = useCallback(() => homeUrl && backToHome(homeUrl), [homeUrl]);

  return (
    <S.Wrapper>
      <ConfirmationPage pageType="error">
        <FlameIcon />
        <Headline5 m={16} textAlign="center">
          {i18n(i18nKey`title`)}
        </Headline5>
        <S.Paragraph>{status}</S.Paragraph>
        <ButtonPrimaryDark onClick={onClickHandler}>{i18n(i18nKey`tohome`)}</ButtonPrimaryDark>
      </ConfirmationPage>
    </S.Wrapper>
  );
}

export default memo(ErrorPage);
